<template>
  <div class="container-fluid container-wrap col-sm-12 col-xs-12">
    <div class="row justify-content-center">
      <div class="col-sm-12 col-xs-12">
        <div class="card-header pb-0 col-sm-12 d-flex mainDiv">
          <div class="col-sm-12 col-xs-12">
            <div class="col-sm-12 col-xs-12 titleDiv">
              <h3 class="subTitle">{{ $t('notices_title') }}</h3>
              <h5>{{ $t('notices_desc') }}</h5>
            </div>
            <div class="card-body px-0 pt-0 pb-2">
              <div
                class="card content-wrap-card col-sm-12 col-xs-12"
                style="padding: 0px 8px !important"
              >
                <div class="table-responsive p-0">
                  <table class="table align-items-center mb-0 seanTable">
                    <colgroup>
                      <col width="85%" />
                      <col width="15%" />
                    </colgroup>
                    <thead>
                    <tr>
                      <th
                          class="text-uppercase text-secondary font-weight-semibold opacity-7 text-left"
                      >
                        {{ title }}
                      </th>
                      <th
                          class="text-uppercase text-secondary font-weight-normal opacity-7 ps-2"
                      >
                        {{ convertDate(createAt) }}
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <div class="contentDiv" ref="contentDiv"></div>
                    </tbody>
                    <tfoot
                        v-if="existingAttachments.length > 0"
                        class="tfoot-wrap"
                        style="border-top: 1px solid #e9ecef"
                    >
                    <div class="tfoot-left">{{ $t('notices_attachment') }}</div>
                    <div class="tfoot-right">
                      <div
                          class="file-row"
                          v-for="(file, index) in existingAttachments"
                          :key="index"
                      >
                          <span
                              class="title"
                              @click="downloadExistingFile(file)"
                          >{{ file.fileName }}</span
                          >
                      </div>
                    </div>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
            <div style="width: 100%; display: flex; justify-content: center;">
              <a-button type="primary" size="large" @click="backToList">
                {{ $t('notices_tolist') }}
              </a-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { decodeUtfText, convertDate } from '../utils/utils';

export default {
  name: 'NoticeRead',
  components: {},
  data() {
    return {
      // 본문, 제목, 작성자, 첨부파일(복수)
      noticeId: '',
      page: 0,
      title: '', // 제목
      content: '', // 본문
      createAt: '', // 작성 시각
      writer: '', // 작성자
      attachments: [], // 첨부파일
      existingAttachments: [], // 기존에 업로드 되어 있던 첨부파일
      deviceWidth: null,
    };
  },
  props: {
    id: {},
    page: {},
  },
  async mounted() {
    window.addEventListener('resize', this.handleResize);
    this.noticeId = this.$route.params.id;
    this.page = this.$route.query.page;
    await this.getNotice();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.deviceWidth = window.innerWidth;
    },
    // 공지사항 로드
    async getNotice() {
      try {
        const response = await this.$apiInstance.get(
            `/notices/${this.noticeId}`
        );
        if (response.status === 200 || response.status === 201) {
          this.$refs.contentDiv.innerHTML = response.data.contents;
          this.title = response.data.title;
          this.writer = response.data.writer;
          this.createAt = response.data.createAt;
          if (response.data.fileUrls && response.data.fileUrls.length > 0) {
            for (const item of response.data.fileUrls) {
              const fileUrlArray = item.split('/');
              const obj = {};
              obj.fileName = decodeUtfText(
                  fileUrlArray[fileUrlArray.length - 1]
              );
              obj.fileUrl = item;
              this.existingAttachments.push(obj);
            }
          }
        }
      } catch (error) {
        console.log(error);
        oneBtnDialog(this.$i18n.t('notices_load_err_title'), this.$i18n.t('notices_load_err_content'), false);
      }
    },
    // 기존에 등록된 파일 다운로드
    downloadExistingFile(file) {
      const downloadLink = document.createElement('a');
      downloadLink.target = '_blank';
      downloadLink.href = file.fileUrl;
      downloadLink.download = file.fileName;
      downloadLink.click();
    },

    backToList() {
      this.$router.go(-1);
      // this.$router.push({ name: "NoticeList", query: {page: this.page} });
    },
    initContent() {
      this.content = '';
      this.title = '';
    },
    convertDate,
  },
};
</script>
<style scoped>


.tfoot-wrap {
  padding-top: 20px;
  display: flex;
  align-items: center;
}
.tfoot-left {
  width: 150px;
  color: rgb(75, 81, 88);
  font-weight: 500;
  height: 60px;
  display: flex;
  align-items: center;
}
.tfoot-right {
  display: flex;
  align-items: center;
  height: 60px;
}
.file-row {
  padding: 10px 12px;
  align-items: center;
  gap: 8px;
  background-color: #e3e6e9 !important;
  border: solid 1px #d4d7da !important;
  border-radius: 8px;
  margin-right: 8px;
  &:hover {
    cursor: pointer;
  }
}

.contentDiv img {
  max-width: 100% !important;
  height: auto;
}

.seanTable {
  th {
      color: #4B5158 !important;
      padding: 0 16px !important;
  }

  tbody {
      .contentDiv {
          width: 100%;
          padding: 24px;

          p {
              padding: 0;
              margin-bottom: 0;
          }
      }
  }
}
</style>
